<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title" v-t="'message.title_edit_user_information'">
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <el-form label-width="170px" class="dialog-form-item">
                        <!--- ユーザーID --->
                        <el-form-item prop="userName" ref="userName">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_userId'"></span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_userId')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="userName" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="userAttribute.name" :disabled="true"
                                 @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                 clearable @clear="inputCheckAll()"/>
                        </el-form-item>
                        <!--- ユーザー表示名 --->
                        <el-form-item prop="displayName" ref="displayName">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_userDisplayName'"></span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_user_display_name')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="displayName" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.displayName.value"
                                 @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                 clearable @clear="inputCheckAll()"/>
                        </el-form-item>

                        <!--- 組織名 --->
                        <el-form-item prop="organization" ref="organization">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_organization'"/>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_searching_user_item')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="organization" size="large" type="text" v-model="inputForm.organization.value"
                                    @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                    clearable @clear="inputCheckAll()"/>
                        </el-form-item>
                        <!--- 役職名 --->
                        <el-form-item prop="title" ref="title">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_job_title'"/>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_searching_user_item')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="title" size="large" type="text" v-model="inputForm.title.value"
                                    @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                    clearable @clear="inputCheckAll()"/>
                        </el-form-item>
                        <!--- 割込み通話権限 --->
                        <el-form-item v-if="canEditAllIpRadioInfo" style="text-align:right" label-width="280px">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_option_interrupt_permission'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_option_interrupt_permission'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch v-model="userOptions.interrupt" active-color="#5171cb" @change="handleOptionChange('interrupt')"></el-switch>
                        </el-form-item>

                        <p class="beside-line" v-t="'message.item_ip_radio'"></p>
                        <!--- 使用回線 --->
                        <template v-if="canEditAllIpRadioInfo">
                            <template v-if="FEATURE_JKC_SEPARATE_CURRENT_LINE_FROM_PRIMARY_LINE">
                                <el-form-item v-if="userAttribute.currentLine != null">
                                    <div slot="label" style="text-align:left">
                                        <span v-t="'message.item_ip_radio_Info_current_line'"></span>
                                    </div>
                                    <div class="dialog-static-text">{{ currentLineDisplay }}</div>
                                </el-form-item>
                            </template>
                            <el-form-item prop="primaryLine" ref="primaryLine">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_ip_radio_Info_primary_line'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <!-- <div slot="content" style="text-align:left" v-html="$t('message.hint_talk_type')"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/> -->
                                    </el-tooltip>
                                </div>
                                <el-select class="select-option-item" v-model="primaryLine" @change="setButtonStatus()">
                                    <el-option v-for="primaryLine in primaryLineList" :label="primaryLine.value" :value="primaryLine.key"></el-option>
                                </el-select>
                            </el-form-item>
                            <p class="option-description">
                                ■ この設定を変更すると、端末の回線設定が変更されます。<br>
                                ■ 回線設定は、無線機の起動時に反映されます。
                            </p>
                        </template>
                        <!--- カスタム項目1 --->
                        <el-form-item prop="customField1" ref="customField1">
                            <div slot="label" style="text-align:left">
                                {{appData.customFieldName}}
                                <el-tooltip effect="dark" placement="top-start">
                                </el-tooltip>
                            </div>
                            <el-input id="customField1" size="large" type="text" v-model="inputForm.customField1.value"
                                    @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                    clearable @clear="inputCheckAll()"/>
                        </el-form-item>
                        <!--- STUN --->
                        <template v-if="FEATURE_JKC_STUN && canEditAllIpRadioInfo">
                            <p class="beside-line" v-t="'message.item_ip_radio_Info_stun_title'"></p>
                            <el-form-item style="text-align:right" label-width="280px">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_ip_radio_Info_stun'"></span>
                                </div>
                                <el-switch v-model="isStun" active-color="#5171cb" @change="handleOptionChange('stun')"></el-switch>
                            </el-form-item>
                        </template>

                        <p class="beside-line" v-t="'message.item_option'"></p>
                        <p class="option-description">
                            <span v-t="'message.hint_option_description8'"/><br>
                        </p>
                        <!--- 動態管理オプション --->
                        <el-form-item v-if="canEditAllIpRadioInfo && isVisibleUserOption('tracking')" style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_option_location_tracking'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_option_location_tracking'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch v-model="userOptions.tracking" active-color="#5171cb" @change="handleOptionChange('tracking')"></el-switch>
                        </el-form-item>
                    </el-form>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="this.$data.disableButton" @click="saveChange()" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import characterCheck from './charactercheck.js';
import commonUtil from './commonutil.js';
import commonValidate from './common-validate.js';
import constants from './constants.js';

import {FEATURE_JKC_STUN, FEATURE_JKC_SEPARATE_CURRENT_LINE_FROM_PRIMARY_LINE} from "@/components/feature_toggles/feature_toggle";

export default {
    data() {
        return {
            inputForm: {
                userName:     { validationRule:"userId",               valid:true, value:null, isComposing:false, requiredForAdmin:true  },
                displayName:  { validationRule:"reqDisplayName",       valid:true, value:null, isComposing:false, requiredForAdmin:true  },
                organization: { validationRule:"displayName",          valid:true, value:null, isComposing:false, requiredForAdmin:false },
                title:        { validationRule:"displayName",          valid:true, value:null, isComposing:false, requiredForAdmin:false },
                customField1: { validationRule:"displayName",          valid:true, value:null, isComposing:false, requiredForAdmin:false },
            },
            userOptions: {
                tracking:       false,
                interrupt:      false,
            },
            isStun: false,

            inputTypeOfPassword: "password",
            passwordShowHideButton: "SHOW",
            disableButton: true,
            primaryLineList: [],
            primaryLine: null,
        };
    },
    methods: {
        saveChange: function() {
            this.inputCheckAll();
            if (!commonValidate.checkFormValidation(this.inputForm)) {
                this.disableButton = true;
                return;
            }

            let newUserOptions = null;
            if (this.canEditAllIpRadioInfo) {
                newUserOptions = {};
                if (this.userAttribute.userOptions.tracking != this.userOptions.tracking) {
                    newUserOptions.tracking = this.userOptions.tracking;
                }
                if (this.userAttribute.userOptions.interrupt != this.userOptions.interrupt) {
                    newUserOptions.interrupt = this.userOptions.interrupt;
                }
                if (Object.keys(newUserOptions).length == 0) {
                    newUserOptions = null;
                }
            }

            let input = {}
            for (let key in this.inputForm) {
                if (this.isAdminUser) {
                    if (this.inputForm[key].requiredForAdmin) {
                        input[key] = this.inputForm[key].value
                    }
                } else {
                    input[key] = this.inputForm[key].value
                }
            }
            if (this.canEditAllIpRadioInfo) {
                input["primaryLine"] = this.primaryLine;
                input["isStun"] = this.isStun;
            }
            this.$emit('save', input, newUserOptions);
        },
        handleOptionChange: function(changedOption) {
            if(changedOption == "tracking" && this.userAttribute.optionCode == null){
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_need_location_tracking_option_ip_radio"));
                this.userOptions.tracking = false;
            }
            this.setButtonStatus();
        },
        handleChangePasswordCheck() {
            if (this.inputTypeOfPassword == "password") {
                this.inputTypeOfPassword = "text";
            } else {
                this.inputTypeOfPassword = "password";
            }
        },
        setButtonStatus: function() {
            if (commonValidate.checkFormValidation(this.inputForm)) {
                this.disableButton = false;
            } else {
                this.disableButton = true;
            }
        },
        inputCheck(eventTargetId) {
            if (this.inputForm[eventTargetId].isComposing) {
                // inputting with IME
                return;
            }
            let validateResult = commonValidate.validateItem(this.$i18n, this.inputForm[eventTargetId].validationRule, this.inputForm[eventTargetId].value);
            if (validateResult.valid) {
                this.inputForm[eventTargetId].valid = true;
                this.$refs[eventTargetId].clearValidate();
            } else {
                this.inputForm[eventTargetId].valid = false;
                this.$refs[eventTargetId].validateState = "error";
                this.$refs[eventTargetId].validateMessage = validateResult.message;
            }
            this.setButtonStatus();
        },
        inputCheckAll() {
            for (let targetId in this.inputForm) {
                this.inputCheck(targetId);
            }
        },
        compositionStart(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = true;
        },
        compositionEnd(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = false;
            this.inputCheck(eventTargetId)
        },
        isVisibleUserOption(optionName) {
            if (this.appData.basicContract.planType == constants.LICENSE_PLAN_SEPARATE) {
                return commonUtil.isVisibleUserOption(this.appData.onlinePurchase, optionName);
            } else {
                return true;
            }
        }
    },
    created: function() {
        this.primaryLineList = commonUtil.getIpRadioPrimaryLineFilteredList(this.userAttribute.enableLineFlag);
        this.primaryLine = this.userAttribute.primaryLine;
        this.inputForm.userName.value = this.userAttribute.name;
        this.inputForm.displayName.value = this.userAttribute.displayName;
        if (!this.isAdminUser) {
            this.inputForm.organization = { validationRule: "displayName",      valid: true, value: this.userAttribute.organization,    isComposing: false  };
            this.inputForm.title        = { validationRule: "displayName",      valid: true, value: this.userAttribute.title,           isComposing: false  };
            this.inputForm.customField1 = { validationRule: "displayName",      valid: true, value: this.userAttribute.customField1,    isComposing: false  };

            this.isStun = this.userAttribute.isStun;

            this.userOptions.tracking = this.userAttribute.userOptions.tracking;
            this.userOptions.interrupt = this.userAttribute.userOptions.interrupt;
        }
    },
    mounted: function() {
        // tabIndex of tooltip was always set to 0 (Should set -1 to skip focus)
        for (let element of document.getElementsByClassName('icon-help')) {
            element.setAttribute("tabIndex", "-1");
        }
    },
    watch: {
        inputTypeOfPassword(newVal) {
            if (newVal == "password") {
                this.passwordShowHideButton = "SHOW";
            } else {
                this.passwordShowHideButton = "HIDE";
            }
        }
    },
    computed: {
        canEditAllIpRadioInfo() {
            return this.appData.radioManageUser
        },
        currentLineDisplay() {
            return commonUtil.getIpRadioPrimaryLine(this.userAttribute.currentLine);
        },
        showPrimaryLineNotice() {
            return this.primaryLine !== this.userAttribute.primaryLine;
        },
        showOptionSetting: function() {
            if (this.appData.onlinePurchase) {
                if (this.appData.basicContract.planType != constants.LICENSE_PLAN_SEPARATE) {
                    return true;
                } else {
                    if ((this.appData.enableSpeechTextOption) || (this.appData.enableSpeechTextTrial)) {
                        return true;
                    } else {
                        return false;
                    }
                }
            } else {
                return true;
            }
        },

        FEATURE_JKC_STUN: () => FEATURE_JKC_STUN,
        FEATURE_JKC_SEPARATE_CURRENT_LINE_FROM_PRIMARY_LINE: () => FEATURE_JKC_SEPARATE_CURRENT_LINE_FROM_PRIMARY_LINE,
    },
    props: {
        appData: Object,
        userAttribute: Object,
        talkgroupInfos: Object,
        isAdminUser: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped>
button.input-pass-check {
    border-style: none;
    background-color: #fff;
    cursor: pointer;
    outline: none;
    position: absolute;
    height: 20px;
    width: 44px;
    left: 305px;
    top: 2px;
    z-index: 10;
    color: #848991;
    font-size: 10px;
}

.dialog-static-text {
    min-height: 40px;
    left: 15px;
    position: absolute;
    display: flex;
    align-items: center;
}

</style>
